/* ==========================================
   URHUL INSTALL APP - START
========================================== */

let deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();

  deferredPrompt = e;

  const installButton = document.getElementById("install-app-btn");

  if (installButton) {
    installButton.style.display = "inline-flex";
  }
});

document.addEventListener("click", async function (e) {

  if (!e.target.closest("#install-app-btn")) return;

  if (!deferredPrompt) return;

  deferredPrompt.prompt();

  const choiceResult = await deferredPrompt.userChoice;

  if (choiceResult.outcome === "accepted") {
    console.log("PWA Installed");
  }

  deferredPrompt = null;

  const installButton = document.getElementById("install-app-btn");

  if (installButton) {
    installButton.style.display = "none";
  }

});

window.addEventListener("appinstalled", () => {

  const installButton = document.getElementById("install-app-btn");

  if (installButton) {
    installButton.style.display = "none";
  }

});

/* ==========================================
   URHUL INSTALL APP - END
========================================== */